import type { Dictionary } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class CampusEventFilter extends AdornisFilter {
  static override _class = 'CampusEventFilter';

  constructor(doc: Partial<EntityData<CampusEventFilter>>) {
    super(doc);
  }

  override searchFields: string[] | undefined = ['title', 'description'];

  @Field(() => [String])
  eventIDs?: string[];

  @Field(() => String)
  forUserID?: string;

  @Field(() => String)
  area?: string;

  override getMongoFilter() {
    const selector: Dictionary<any> = super.getMongoFilter();
    const obj = this.toObject();

    if (obj.eventIDs && obj.eventIDs?.length > 0) {
      selector._id = { $all: Array.from(obj.eventIDs) };
    }

    if (obj.area) {
      selector.area = obj.area;
    }

    return selector;
  }
}
